<div class="no-results">
    <mat-icon>{{ icon() }}</mat-icon>
    <h5 class="upper">{{ message() | translate }}</h5>
    @if (actionLabel()) {
        <button class="btn" type="button" (click)="action.emit()">{{ actionLabel()! | translate }}</button>
    }
</div>
